module.exports = __webpack_public_path__ + "static/4k-logo.5c117a10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k-logo.svg
// module id = 600
// module chunks = 35783957827783